<div class="project-config-node" (mouseenter)="hovering.emit(true)" (mouseleave)="hovering.emit(false)">
  <div class="node-inner">
    <app-svg-icon
      class="drag-handle"
      icon="drag-drop-vertical"
      color="var(--color-grey-900)"
      [strokeWidth]="3"
    ></app-svg-icon>
    @if (editing()) {
      <ng-container *ngTemplateOutlet="editTemplate"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="displayTemplate"></ng-container>
    }
  </div>
</div>
